import ActivityLabel from './ActivityLabel';

export default ActivityLabel;
